import { render } from "./PdfPageHeader.vue?vue&type=template&id=95d0c98c&scoped=true&ts=true"
import script from "./PdfPageHeader.vue?vue&type=script&lang=ts"
export * from "./PdfPageHeader.vue?vue&type=script&lang=ts"

import "./PdfPageHeader.vue?vue&type=style&index=0&id=95d0c98c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d0c98c"]])

export default __exports__